import Vue from 'vue'
import Vuex from "vuex"
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Chart from 'chart.js'

Vue.config.productionTip = false

Vue.use(Vuex);
Vue.use(VueAxios, axios)

const store = new Vuex.Store(
    {
        state: {
            username: '',
            password: '',
            authenticated: false,
            returnUrl: ''
        },
        mutations: {
            setAuthentication(state, status) {
                state.authenticated = status;
            }
        }
    }
);

export default store

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
